import React from "react";
import Svg from "../../../../common/Svg";
import { getHintButtonAriaLabel } from "../utils/accessibility";

export function FieldHintButton({ fieldLabel, hint, hintStyle = "" }) {
  if (!hint) {
    return null;
  }

  return (
    <div className={`hint ${hintStyle}`}>
      <button
        type="button"
        className="info"
        tabIndex={0}
        aria-label={getHintButtonAriaLabel(fieldLabel)}
      >
        <Svg name="hint-button" />
      </button>
      <div className="popover" dangerouslySetInnerHTML={{ __html: hint }} />
    </div>
  );
}
